import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Button } from '@ui/buttons/Button.tsx';
import { Icon } from '@ui/icons/Icon.tsx';
import { isRtl } from '@utils/dom.ts';

import { useCSSColors } from '../../../../src/hooks/useCSSColors.ts';

const NavBarMobile = styled.div`
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  flex: 0 0 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;

  button {
    padding: 0;
    margin-block: 0;
    margin-inline: 10px 0;
  }

  .userMenu {
    width: 40px;
    height: 40px;
    padding: 0;
    color: ${({ $fillColor }) => $fillColor};
  }
`;

const SearchModeMobile = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .arrowBack {
    margin-block: 0;
    margin-inline: 6px 16px;
  }

  input {
    width: 100%;
    outline: none;
    border: none;
    height: 40px;
    font-size: 16px;
    line-height: 150%;
    padding: 0 9px;
    opacity: 0.1;
    border-radius: 2px;

    &::placeholder {
      color: #ffffff;
    }
  }
`;

const StyledButton = styled(Button)`
  &:focus-visible {
    outline-offset: -2px;
  }
`;

const SearchNavMobile = ({
  searchPlaceholder,
  logoUrl,
  onToggleSearchButtonClick,
  onOpenDirectionsSearchButtonClick,
}) => {
  const colors = useCSSColors();

  if (logoUrl) {
    return (
      <NavBarMobile $fillColor={colors.widgetIconFill}>
        <StyledButton className="search" onClick={onToggleSearchButtonClick} title="Search" data-testid="searchButton">
          <Icon name="search" cdn height={40} width={40} fillColor={colors.widgetIconFill} />
        </StyledButton>
        <StyledButton
          className="directions"
          onClick={onOpenDirectionsSearchButtonClick}
          title="Directions"
          data-testid="OpenDirectionsButton"
        >
          <Icon name="directions-filled" cdn height={40} width={40} fillColor={colors.widgetIconFill} />
        </StyledButton>
      </NavBarMobile>
    );
  }

  return (
    <SearchModeMobile>
      <div className="arrowBack">
        <Icon name={isRtl() ? 'arrow-right' : 'arrow-left'} cdn height={32} width={32} />
      </div>
      <input value="" readOnly placeholder={searchPlaceholder} />
    </SearchModeMobile>
  );
};

SearchNavMobile.propTypes = {
  searchPlaceholder: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  onToggleSearchButtonClick: PropTypes.func.isRequired,
  onOpenDirectionsSearchButtonClick: PropTypes.func.isRequired,
  onUserMenuButtonClick: PropTypes.func.isRequired,
};

export default SearchNavMobile;
